import React from 'react';
import css from 'styled-jsx/css';
import ButtonBecomeCreator from '../ButtonBecomeCreator';
import themeVariables from '~/shared/themeVariables';
import config from '~/config';
import I18nLink from '~/components/I18nLink';

const FAQ = ({ t, lng, style }) => {
  const faqLink =
    lng === 'tw'
      ? 'https://global.help.freebie-ac.jp/tw/'
      : 'https://global.help.freebie-ac.jp';
  return (
    <div className="faq">
      <div className="faq-container">
        <div className="faq-container-01">
          <div className="container-faq-img-01-ipad">
            {config.isPhotoAC() ? (
              <img
                className="img-faq-01-ipad lazyload"
                data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/photoac_faq_01_ipad.png`}
              />
            ) : (
              <img
                className="img-faq-01-ipad lazyload"
                data-srcset={`${config.staticPrefix}/static/assets/landing-page-illustac/illustac_faq_01_ipad.svg`}
              />
            )}
          </div>
          <div className="overlay-01">
            <h3 className="heading-faq-01 text-header">
              {t('photoac_landing_page_heading_faq_01')}
            </h3>
            <ul className="content-faq-01 text-body">
              <li> {t('photoac_landing_page_content01_faq_01')} </li>
              <li> {t('photoac_landing_page_content02_faq_01')}</li>
              <li>{t('photoac_landing_page_content03_faq_01')}</li>
              <li>{t('photoac_landing_page_content04_faq_01')}</li>
              <li>{t('photoac_landing_page_content05_faq_01')}</li>
            </ul>
            <I18nLink href="/submission-guideline">
              <a className="link-submission">
                {t('photoac_landing_page_link_faq_01')}
              </a>
            </I18nLink>
          </div>
          <div className="container-faq-img-01">
            {config.isPhotoAC() ? (
              <img
                className="img-faq-01 lazyload"
                data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/photoac_faq_01.png`}
              />
            ) : (
              <img
                className="img-faq-01 lazyload"
                data-srcset={`${config.staticPrefix}/static/assets/landing-page-illustac/illustac_faq_01.png`}
              />
            )}
          </div>
          <div className="wiggle-faq-container">
            <img
              className="wiggle-faq-01-ipad lazyload"
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/wiggle-faq-ipad.png`}
            />
          </div>
        </div>
        <div className="faq-container-02">
          {config.isPhotoAC() ? (
            <img
              className="img-faq-02 lazyload"
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/photoac_faq_02.png`}
            />
          ) : (
            <img
              className="img-faq-02 lazyload"
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-illustac/illustac_faq_02.png`}
            />
          )}

          {config.isPhotoAC() ? (
            <img
              className="img-faq-02-ipad lazyload"
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/photoac_faq_02_ipad.png`}
            />
          ) : (
            <img
              className="img-faq-02-ipad lazyload"
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-illustac/illustac_faq_02_ipad.svg`}
            />
          )}

          <div className="overlay-02">
            <h3 className="heading-faq-02 text-header">
              {t('photoac_landing_page_heading_faq_02')}
            </h3>
            <ul className="content-faq-02 text-body">
              <li>
                <b> {t('photoac_landing_page_content01_faq_02')}</b>{' '}
              </li>
              <p>{t('photoac_landing_page_sub_content01_faq_02')}</p>
              <li>
                {' '}
                <b> {t('photoac_landing_page_content02_faq_02')}</b>
              </li>
              <p>{t('photoac_landing_page_sub_content02_faq_02')}</p>
              <li>
                {' '}
                <b>{t('photoac_landing_page_content03_faq_02')}</b>
              </li>
              <p>{t('photoac_landing_page_sub_content03_faq_02')}</p>
              <p>{t('photoac_landing_page_sub_content03_02_faq_02')}</p>
            </ul>
            <a href={faqLink} className="link-submission">
              {t('photoac_landing_page_link_faq_02')}
            </a>
          </div>
        </div>
      </div>
      <div className="wiggle-faq-container-faq-finish">
        <img
          className="wiggle-faq-01-ipad lazyload"
          data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/wiggle-faq-ipad.png`}
        />
      </div>
      <div className="faq-infor">
        <div className="faq-infor-container">
          <div className={`overlay-infor ${config.serviceType}`}>
            <h3 className="heading-infor text-header">
              {t('photoac_landing_page_heading_infor')}
            </h3>
            <p className="content-infor text-body">
              {t('photoac_landing_page_content_infor')}
            </p>
            <ButtonBecomeCreator
              t={t}
              style={{ marginTop: themeVariables.space.base }}
            />
          </div>
          <div className={`img-infor-wiggle-container ${config.serviceType}`}>
            <img
              className="img-infor-wiggle lazyload"
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/wiggle_infor.png`}
            />
          </div>

          {config.isPhotoAC() ? (
            <img
              className="img-infor-ipad photoac lazyload"
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/photoac_infor_01_ipad.png`}
            />
          ) : (
            <img
              className="img-infor-ipad illustac lazyload"
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-illustac/illustac_infor.png`}
            />
          )}
          {config.isPhotoAC() ? (
            <img
              className="img-infor lazyload"
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/photoac_infor_01.png`}
            />
          ) : (
            <img
              className="img-infor illustac lazyload"
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-illustac/illustac_infor.png`}
            />
          )}
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};
const styles = css`
  .text-body{
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 28px;
  }
  .text-header{
    font-style: normal;
    font-weight: 600;
    font-size: 40px;
    line-height: 47px;
    letter-spacing: -0.03em;
  }
  .faq {
    background: white;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #f8f9fa;
  }
  .faq-container {
    width: 100%;
    max-width: 1248px;
    display: flex;
    flex-direction: column;
  }
  .faq-container-01 {
    width: 100%;
    max-width: 1248px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    position: relative;
  }
  .overlay-01 {
    position: absolute;
    width: 50%;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: #fff;
    padding-bottom: 8%;
    padding-top: 2%;
    z-index: 800;
    padding-right: 32px;
  }
  .heading-faq-01 {
    color: #1b2833;
    margin: 32px 0px;
  }
  .content-faq-01 {
    color: #1b2833;
    list-style-type: none;
    padding-left: 0; */
  }
  .content-faq-01 li {
    margin: 8px 0;
  }
  .link-submission{
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    text-decoration-line: underline;
    color: #509BDC;
  }
  .container-faq-img-01{
    position: relative;
    top: -50px;
    width: 50%;
  }
  .img-faq-01 {
    position: relative;
    width: -webkit-fill-available;
  }

  .faq-container-02 {
    width: 100%;
    max-width: 1248px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    position: relative;
  }
  .overlay-02 {
    position: relative;
    width: 50%;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: #fff;
    padding-bottom: 25%;
    padding-top: 0%;
    z-index: 800;
  }
  .img-faq-02 {
    position: absolute;
    left: 0;
    top: 12%;
    width:45%;
  }
  .heading-faq-02 {
    color: #1b2833;
    margin: 32px 0px;
  }
  .content-faq-02 {
    color: #1b2833;
    list-style-type: none;
    padding-left: 0; */
  }
  .content-faq-02 li {
    margin: 8px 0;
  }
  .faq-infor{
    width:100%;
    height: 584px;
    background: ${config.isPhotoAC() ? '#1B2833' : '#454285'};
    display: flex;
    flex-direction: row;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: relative;
  }
  .faq-infor-container{
    width: 100%;
    max-width: 1248px;
    display: flex;
    flex-direction: row;

    position: relative;
  }
  .overlay-infor {
    position: relative;
    width: 45%;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: #FFFFFF;
    padding-bottom: 5%;
    padding-top: 0%;
    padding-left: 32px;
    z-index: 800;
  }
  .heading-infor{
    color: #FFFFFF;
    margin: 32px 0px;
  }
  .content-infor{
    color: #FFFFFF;
  }
  .img-infor{
    position: absolute;
    right: 0;
    top: -25%;
  }
  .img-infor.illustac{
    max-height:650px;
  }
  .img-infor-wiggle-container{
    position: absolute;
    margin-left: 32px;
    top: 100%;
  }
  .img-infor-wiggle {
    position: relative;
    left: 0;
    top: 100%;
    width: inherit;
  }
  .img-faq-01-ipad{
    display:none
  }
  .wiggle-faq-container{
    display:none;
  }
  .img-faq-02-ipad{
    display:none;
  }
  .img-infor-ipad{
    display:none;
  }
  .img-infor-wiggle-container.photo_ac{
      width: 65%;
  }
  .wiggle-faq-container-faq-finish{
    display:none;
  }
  @media screen and (min-width: 905px) and (max-width: 1239px) {
    .heading-faq-01 {
      color: #1b2833;
      margin: 8px 0px;
      font-size: 24px;
    }
    .heading-faq-02{
      font-size: 24px;
      margin: 8px 0px;
    }
    .img-faq-02 {
      position: absolute;
      left: 0;
      top: 12%;
      width:45%;
    }
    .overlay-02 {
      padding-bottom: 15%;
    }
    .img-infor{
      top: -15%;
      width: 45%;
      right: 32px;
    }
    .img-infor.illustac{
      max-height:650px;
      margin-top:-80px;
    }
    .heading-infor{
      color: #FFFFFF;
      margin: 8px 0px;
      font-size: 24px;
      line-height: 28px;
    }
    .img-infor-wiggle-container{
      margin-top:50px;
      width:65%;
    }
    .img-infor-wiggle {
    }
    .overlay-infor {
      padding-top: 20px;
    }

    .faq-container-01{
      padding :0 32px
    }
    .faq-container-02{
      padding :0 32px
      margin-top:130px;
    }
    .img-faq-02 {
      padding-left : 32px

    }
    .overlay-01{
      padding: 0 32px;
      height:fit-content;
      position:relative;
    }
    .wiggle-faq-container-faq-finish{
      display:none;
    }
  }
  @media screen and (min-width: 730px) and (max-width: 904px) {
    .wiggle-faq-container-faq-finish{
      display:block;
      width: 100%;
      margin-bottom: 20px;
    }
    .faq-container-01{
      display:block;
      margin-top:12%;

    }
    .img-faq-01{
      display:none;
    }
    .img-faq-01-ipad{
      display:block;
      position:relative;
      width:100%;
      padding: 0 16px;
    }
    .container-faq-img-01{
      position: relative;
      top:100px;
      width: 100%;
    }
    .overlay-01{
      position:relative;
      width:100%;
    }
    .heading-faq-01 {
      font-size:24px;
      line-height: 28px;
      margin:8px 0;
    }
    .wiggle-faq-container{
      padding:10px 0;
      display:block;
    }
    .wiggle-faq-01-ipad{
      position: relative;
      width: 100%;
      padding: 0 16px;

    }
    .faq-container-02{
      display:block;
      margin-top:10px;
    }
    .img-faq-02{
      display:none;
    }
    .img-faq-02-ipad{
      display:block;
      width:100%;
    }
    .img-faq-02-ipad{
      display:block;
      position:relative;
      width:100%;
      padding: 0 16px;
    }
    .overlay-02{
      width:100%;
      padding-bottom:15%;
    }
    .heading-faq-02 {
      font-size:24px;
      line-height: 28px;
      margin:8px 0;
    }
    .img-infor{
      display:none;
    }
    .img-infor-ipad{
      display:block;
      margin-right: 16px;
      margin-top: -40px;
    }
    .img-infor-ipad.illustac{
      position: unset;
    top: unset;
    max-height: 500px;
    margin-top: -130px;
    width: auto;
    right: unset;
    }

    .img-infor-wiggle-container{
      width: 60%;
      top: 80%;
    }
    .img-infor-wiggle-container.photo_ac{
      width: 65%;
    }
    .img-infor-wiggle{
    }
    .heading-infor{
      font-size: 24px;
      line-height: 28px;
    }
    .overlay-infor{
      padding-bottom:0;
    }
    .overlay-infor.photo_ac {
      width:55%;
    }
    .faq-infor{
      height:435px;
      margin-top: 100px;
    }
    .overlay-01{
      padding: 0 16px;
    }
    .overlay-02{
      padding: 0 16px;
    }

  }
`;
export default FAQ;
